import { Col, Form, Input, message, Modal, Radio, Row, Select, Space } from "antd";
import AreaCode from "@src/assets/international/AreaCode.json";
import { useEffect, useMemo, useState } from "react";
import { ReactComponent as CheckFilled } from "@src/assets/CN/svg/check-filled.svg";
import { ReactComponent as CheckEmpty } from "@src/assets/CN/svg/check-empty.svg";
import { ReactComponent as BlackCall } from "@src/assets/CN/svg/black-call.svg";
import { ReactComponent as CaretDown } from "@src/assets/CN/svg/caret-down-small.svg";
import { ReactComponent as Close } from "@src/assets/CN/svg/close.svg";
import { addUserContactCN } from "@src/Api/CN";
import { useTranslation } from "react-i18next";
import CNEnum from "@src/Locales/Constants/CNEnum";
import i18n from "@src/Basic/Language/i18n";
import { Popup } from "antd-mobile";
import useContactOpts from "@src/Hooks/CN/useContactOpts";
import { t } from "i18next";
import styles from "./index.module.less";
import _ from "lodash";

const { TextArea } = Input;

const renderAreaOptions = (option: any) => {
  // 宽度是跟随form select 内容的宽度的变化的
  return (
    <p className="text-black/[0.88] m-0 p-0 box-border">
      {option.data.Country} + {option.data.CountryCode}
    </p>
  );
};

const renderLabel = (title: string, isRequired = true) => {
  return (
    <div className={`flex items-center gap-[2px] text-[#717171]`}>
      {isRequired && <label className="text-[#FF4D4F]"> * </label>}
      <label>{title}</label>
    </div>
  );
};

const handleFilterAreaOption = (input: string, option?: any) => {
  return (
    String(option?.CountryCode)?.includes(input) ||
    option?.Country?.toLowerCase().includes(input.toLowerCase())
  );
};

export const FieldCompanyName = () => {
  return (
    <Form.Item
      label={renderLabel(t(CNEnum.corporateName))}
      name="companyName"
      rules={[{ required: true, message: t(CNEnum.pleaseInput) }]}
    >
      <Input placeholder={t(CNEnum.pleaseInput)} />
    </Form.Item>
  );
};

export const FieldFirstName = () => {
  return (
    <Form.Item
      label={renderLabel(t(CNEnum.contactPerson))}
      name="firstName"
      rules={[{ required: true, message: t(CNEnum.pleaseInput) }]}
    >
      <Input placeholder={t(CNEnum.pleaseInput)} />
    </Form.Item>
  );
};
export const FieldAreaCode = () => {
  return (
    <Form.Item
      label={renderLabel(t(CNEnum.contactPhone))}
      name="areaCode"
      rules={[{ required: true, message: t(CNEnum.pleaseSelect) }]}
    >
      <Select
        placeholder={t(CNEnum.pleaseSelect)}
        style={{ width: "116px" }}
        suffixIcon={<CaretDown />}
        options={_.map(AreaCode, (o) => ({
          ...o,
          CountryCodeLabel: `+${o.CountryCode}`,
        }))}
        fieldNames={{ value: "CountryCode", label: "CountryCodeLabel" }}
        optionRender={renderAreaOptions}
        dropdownStyle={{ width: "300px" }}
        showSearch
        allowClear
      />
    </Form.Item>
  );
};
export const FieldPhoneNumber = () => {
  return (
    <Form.Item
      label={" "}
      name="phoneNumber"
      rules={[{ required: true, message: t(CNEnum.pleaseInput) }]}
    >
      <Input style={{ height: "32px" }} placeholder={t(CNEnum.pleaseInput)} />
    </Form.Item>
  );
};

export const FieldEmail = () => {
  return (
    <Form.Item
      label={renderLabel(t(CNEnum.contactMailbox), true)}
      name="email"
      rules={[{ required: true, message: t(CNEnum.pleaseInput) }]}
    >
      <Input placeholder={t(CNEnum.pleaseInput)} />
    </Form.Item>
  );
};
export const FieldCountry = () => {
  return (
    <Form.Item
      label={renderLabel(t(CNEnum.countryOrRegion))}
      name="country"
      rules={[{ required: true, message: t(CNEnum.pleaseSelect) }]}
    >
      <Select
        options={AreaCode}
        fieldNames={{ value: "CountryCode", label: "Country" }}
        suffixIcon={<CaretDown />}
        showSearch
        allowClear
        filterOption={handleFilterAreaOption}
      />
    </Form.Item>
  );
};

export const FieldContactAddress = () => {
  return (
    <Form.Item
      label={renderLabel(t(CNEnum.contactAddress))}
      name="contactAddress"
      rules={[{ required: true, message: t(CNEnum.pleaseInput) }]}
    >
      <Input placeholder={t(CNEnum.pleaseInput)} />
    </Form.Item>
  );
};

export const FieldBusinessType = (options: any[]) => {
  return (
    <Form.Item label={t(CNEnum.businessFormat)} name="businessType">
      <Select
        placeholder={t(CNEnum.pleaseSelect)}
        style={{ width: "100%" }}
        suffixIcon={<CaretDown />}
        options={options}
      />
    </Form.Item>
  );
};

export const FieldChainStatus = (options: any[]) => {
  return (
    <Form.Item label={t(CNEnum.isChain)} name="chainStatus">
      <Radio.Group options={options} />
    </Form.Item>
  );
};

export const FieldOpeningStatus = (options: any[]) => {
  return (
    <Form.Item label={t(CNEnum.openingStatus)} name="openingStatus">
      <Radio.Group options={options} />
    </Form.Item>
  );
};

export const FieldChannelTypeOpts = (options: any[]) => {
  return (
    <Form.Item label={t(CNEnum.understandChannels)} name="channelTypeOpts">
      <Select
        placeholder={t(CNEnum.pleaseSelect)}
        style={{ width: "100%" }}
        suffixIcon={<CaretDown />}
        options={options}
        allowClear
      />
    </Form.Item>
  );
};
export const FieldObtainServiceContent = () => {
  return (
    <Form.Item label={t(CNEnum.whatHelpHopeReceive)} name="obtainServiceContent">
      <TextArea placeholder={t(CNEnum.pleaseInput)} autoSize maxLength={200} />
    </Form.Item>
  );
};
